<template>
  <div>
    <tool-bar :operation="operation" v-if="!withoutToolbar"
              :message = "message"
              :upload-url="url.import"
              :upload-url1="url.import1"
              :searchLabel="searchLabel"
              @add="onAdd"
              @search="onSearch"
              @delete="onBatchDelete"
              :form="queryParams"
              @beforeUpload="beforeUpload"
              @uploaded="onUploaded"
              @export="onExport">
      <slot name="toolbar"></slot>
      <slot slot="simple-search" name="toolbar-simple-search"></slot>
      <slot slot="buttons" name="buttons"></slot>onDelete
    </tool-bar>
    <slot name="tabs"></slot>
    <paging :url="url.list" :isPages="isPages" :params="queryParams" ref="grid" :manually="manually" @loaded="onLoaded" @loadedOther="onLoadedOther">
      <template slot-scope="grid">
        <slot name="grid" :data="grid.data" :loading="grid.loading"></slot>
      </template>
    </paging>

    <!--新增、编辑 弹出页面-->
    <dialog-form ref="form" :title="dialogNewOrEdit.title" :formTemplate="formTemplate" :visible.sync="visible" :rules="rules" :canEdit="canEdit"
                 :is-edit="isEdit" :form="form" :url="url.save" :type="dialogNewOrEdit.optionType" @visibleDialog="visibleDialog" @beforeSaved="beforeSaved" @saved="onSaved()"
                 :editor="editor" :top="top" :loading="loading">
      <slot name="form"></slot>
      <template slot="dialog-space">
        <slot name="dialog-space"></slot>
      </template>
      <span slot="footer" v-if="changeFooter">
        <slot name="footer"></slot>
      </span>
    </dialog-form>

    <slot name="space"></slot>
  </div>
</template>

<script>
  /**
   * @description 分页表格组件
   * @author tyx
   * @example 使用方式
   * <paging-grid ref="grid" :queryParams.sync="queryParams" :url="url" name="部门">
   *
   *   <!-- 表格 -->
   *   <el-table class="table" slot="grid" slot-scope="grid" :data="grid.data" v-loading="grid.loading" :height="tableHeight" :border="true"
   *     highlight-current-row>
   *     <el-table-column fixed type="index" align="center" label="序号" width="50"></el-table-column>
   *     <el-table-column header-align="center" align="center" prop="RoleName" label="角色名称" width="200"></el-table-column>
   *     <el-table-column :fixed="false" header-align="center" align="center" :sortable="true" prop="RoleState" label="状态" width="100">
   *       <template slot-scope="scope">
   *         <el-tag :type="scope.row.RoleState == 0 ? 'success' : 'danger'" disable-transitions>{{ scope.row.RoleState == 0 ? "正常" : "已删除" }}</el-tag>
   *       </template>
   *     </el-table-column>
   *   </el-table>
   *
   *   <!-- 新增编辑对话框 -->
   *   <template slot="form">
   *     <el-form-item label="角色名称" prop="RoleName">
   *       <el-input v-model="form.RoleName" placeholder="请输入角色名称" clearable></el-input>
   *     </el-form-item>
   *   </template>
   *
   * </paging-grid>
   * @method loadData 加载数据 在父组件中调用方式 this.$refs['grid'].loadData()
   * @param message 提示信息
   * @param url 一个对象，包括多种数据请求地址 完整数据格式包括 list 、 save 、 delete 、 batchDelete
   * @param queryParams 额外查询条件
   * @param operation 用于 toolbar 组件的按钮显示，详见 toolbar 组件
   * @param form 用于 dialog-form 的表单数据，详见 dialog-form 组件
   * @param rules 用于 dialog-form 组件的表单验证，详见 dialog-form 组件
   * @param name 用于 dialog-form 组件的表单标题，详见 dialog-form 组件
   * @param selection 勾选的行数据
   * @param manually 是否手动加载数据
   * @event loaded 数据加载完成后触发，新增、编辑、删除之后都会重新加载数据，因此都会触发
   * @event add 点击新增按钮触发
   */
  import Paging from './Paging'
  import ToolBar from './ToolBar'
  import DialogForm from '../Dialog/DialogForm'

  export default {
    components: {
      Paging,
      ToolBar,
      DialogForm
    },
    props: {
      changeFooter: {
        type: Boolean,
        default: false
      },
      isPages:{
        type: Boolean,
        default: true
      },
      addCanEdit:{
        type: Boolean,
        default: true
      },
      formTemplate: {
          type: Array,
          default: () => []
      },
      withoutToolbar: {
        type: Boolean,
        default: false
      },
      message: {
        type: String
      },
      modeId: {
        type: String
      },
      form: {
        type: Object
      },
      rules: {
        type: Object
      },
      queryParams: {
        type: Object
      },
      url: {
        type: Object,
        default: () => {
        }
      },
      name: {
        type: String
      },
      selection: {
        type: Array
      },
      operation: {
        type: Object
      },
      manually: {
        type: Boolean,
        default: false
      },
      editor: {
        type: Boolean,
        default: false
      },
      top: {
        type: String
      },
      searchLabel:{
        type: String
      }
    },
    data() {
      return {
        visible: false,
        isEdit: false,
        dialogNewOrEdit: {
          optionType: 1,
          title: '',
          form: {}
        },
        loading: false,
        canEdit: true,
      }
    },
    methods: {
      visibleDialog(){
        let self = this;
        self.visible = true;
        self.$emit('visibleDialog')
      },
      onDisplay(row, id, url) {
        this.visible = true;
        this.isEdit = true;
        this.dialogNewOrEdit.optionType = 2;
        this.dialogNewOrEdit.title = '查看' + this.name + '信息';
        this.canEdit = false;
        this.loadRow(row, id, url);
      },
      // 点击编辑
      onEdit(row, id) {
        this.canEdit = true;
        this.visible = true;
        this.isEdit = true;
        if(this.name == '开票'){
          this.dialogNewOrEdit.title = '开票'
        }
        else if(this.name == '赠送'){
          this.dialogNewOrEdit.title = '赠送'
        }
        else{
          this.dialogNewOrEdit.title = '编辑' + this.name + '信息';
        }
        this.dialogNewOrEdit.optionType = 2;
        this.loadRow(row, id);
      },
      loadRow(row, id, url) {
        let self = this;
        self.$emit('beforeLoadRow')
        if(id != undefined && id != null && (self.url.get != undefined || url)) {
          self.loading = true;
          self.$http.post(url || self.url.get, {
            keyValue: id
            // params:{
            //   keyValue: id
            // }
          }).then(result => {
            if (result.state == true) {
              for(var i in self.form){
                if(result.data[i] != undefined){
                  self.form[i] = result.data[i];
                }
              }
              self.$emit("onEditDataLoaded", self.form);
            } else {
              self.$message.error(result.message);
            }
            self.loading = false;
          }, () => {
            self.loading = false;
            self.$message.error('数据加载失败，请检查您的网络是否可用。');
          });
        }
      },
      onAdd() {
        // 触发事件
        this.$emit('add');
        // 显示窗口
        this.isEdit = this.addCanEdit;//this.addCanEdit如果是false就是template中的cannotEidt设置了则为可编辑，如果说新增的时候有些字段就是默认不可编辑那么这个值设为true
        this.canEdit = true;
        this.visible = true;
        this.dialogNewOrEdit.title = '添加' + this.name + '信息';
        this.dialogNewOrEdit.optionType = 1;
        let self = this;
        self.$emit('beforeLoadRow')
        if(self.url.add != undefined && self.url.add != null) {
          self.loading = true;
          self.$http.post(self.url.add, {
            Data: null
          }).then(result => {
            if (result.State == 1) {
              for(var i in self.form){
                if(result.Data[i] != undefined && result.Data[i] != null){
                  self.form[i] = result.Data[i];
                }
              }

              self.$emit("onEditDataLoaded", self.form);
            } else {
              self.$message.error(result.message);
            }
            self.loading = false;
          }, () => {
            self.loading = false;
            self.$message.error('数据加载失败，请检查您的网络是否可用。');
          });
        }
        else {
          self.$emit("onEditDataLoaded");
        }
      },
      save() {
        this.$refs['form'].submitForm('form')
      },
      beforeSaved(){
        this.$emit('beforeSaved');
      },
      onSaved() {
        let self = this;
        self.$refs['grid'].loadData();
        let message;
        if(this.name == '开票'){
          message = '开票成功！'
        }else{
          message = (self.dialogNewOrEdit.optionType == 1 ? '保存' : '保存') + self.name + '成功！';
        }
        this.$message({
          message: message,
          type: 'success'
        });
      },
      reload(url){
        this.$refs['grid'].reload(url);
      },
      beforeUpload() {
        this.loading = true;
        this.$emit("beforeUpload");
      },
      onUploaded(res, file) {
        this.loading = false;
        this.$emit("uploaded", res, file);
      },
      onDelete(id, text) {
        let self = this;
        if (self.url.delete) {
          self.$confirm('将永久删除' + text + ', 是否继续?', '警告', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          }).then(() => {
            self.$http.post(self.url.delete, {
              keyValue: id
            }).then(result => {
                if (result.state == true) {
                  self.$refs['grid'].loadData();
                  self.$message.success('删除成功！');
                } else {
                  self.$message.error(result.message);
                }
              self.uploading = false;
            }, () => {
              self.uploading = false;
              self.$message.error('数据删除失败，请检查您的网络是否可用。');
            });
          }).catch(() => {
            self.$message({
              type: 'info',
              message: '已取消删除操作'
            });
          });
        } else {
          self.$message({
            type: 'info',
            message: '未提供删除方法，请与系统管理员联系。'
          });
        }
      },
      onBatchDelete() {
        let self = this;
        if (!self.selection || self.selection.length == 0) {
          self.$message.warning('您没有选择任何数据，请选择后再进行删除操作！');
          return;
        }
        if (self.url.batchDelete) {
          self.$confirm('此操作将永久删除选中的数据, 是否继续?', '警告', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          }).then(() => {
            let ids = [];
            self.selection.forEach(element => {
              ids.push(element[self.modeId]);
            });
            self.$http.post(self.url.batchDelete, {
              Data: ids
            }).then(result => {
                if (result.State == 1) {
                  self.$refs['grid'].loadData();
                  self.$message.success('删除成功！');
                } else {
                  self.$message.error(result.Message);
                }
              self.uploading = false;
            }, () => {
              self.uploading = false;
              self.$message.error('数据删除失败，请检查您的网络是否可用。');
            });
          }).catch(() => {
            self.$message({
              type: 'info',
              message: '已取消删除操作'
            });
          });
        } else {
          self.$message({
            type: 'info',
            message: '未提供删除方法，请与系统管理员联系。'
          });
        }
      },
      onSearch() {
        // this.$refs['grid'].reload();
        this.$refs['grid'].reloadBySearch();
      },
      onLoaded(dt) {
        // 触发事件
        this.$emit('loaded',dt);
      },
      onLoadedOther(dt) {
        // 触发事件
        this.$emit('onLoadedOther',dt);
      },
      loadData() {
        this.$refs['grid'].loadData();
      },
      onExport() {
        this.$emit('export');
      }
    },
    watch: {
      visible(val) {
        if (val) {
          this.$emit('visible');
        }
        else {
        }
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/tycomponents/Grid/PagingGrid.vue